var html = document.documentElement;
var body = document.body;

offCanvas();
resEmb();
gallery();
stickyNav();
niteMode();



//Burger
function offCanvas() {
    'use strict';
    var burger = document.querySelector('.burger');
    var overlay = document.querySelector('.overlay');
    var canvasClose = document.querySelector('.canvas-close');
    burger.addEventListener('click', function() {
        body.classList.toggle("canvas-opened"); 
    });
    canvasClose.addEventListener('click', function() {
        closeCanvas(); 
    });
    document.addEventListener('keyup', function(e) {
        if (e.keyCode == 27 && body.classList.contains('canvas-opened')) {
           closeCanvas();
        }
    });
    overlay.onclick = closeCanvas

    function closeCanvas(e) {
        if (e !== undefined && e.target !== e.currentTarget) {
            return;
        }
        body.classList.toggle('canvas-opened');
    }
}

//Responsive Embed

function resEmb() {
    'use strict';
    (function(global, factory) {
        typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
            typeof define === 'function' && define.amd ? define(factory) :
            (global = global || self, global.resemb = factory());
    }(this, (function() {
        'use strict';

        function resemb(target, cName) {
            var frames = typeof target === 'string' ? document.querySelectorAll(target) : target;
            var c = cName || 'js-resemb';
            if (!('length' in frames)) frames = [frames];
            for (var i = 0; i < frames.length; i += 1) {
                var frame = frames[i];
                var hasClass = frame.className.split(' ').indexOf(c) !== -1;
                if (hasClass || frame.style.width.indexOf('%') > -1) continue;
                var h = frame.getAttribute('height') || frame.offsetHeight;
                var w = frame.getAttribute('width') || frame.offsetWidth;
                var padding = h / w * 100;
                var div = document.createElement('div');
                div.className = c;
                var divStyles = div.style;
                divStyles.position = 'relative';
                divStyles.width = '100%';
                divStyles.paddingTop = padding + "%";
                var frameStyle = frame.style;
                frameStyle.position = 'absolute';
                frameStyle.width = '100%';
                frameStyle.height = '100%';
                frameStyle.left = '0';
                frameStyle.top = '0';
                frame.parentNode.insertBefore(div, frame);
                frame.parentNode.removeChild(frame);
                div.appendChild(frame);
            }
        }

        return resemb;

    })));

    resemb(document.querySelectorAll('.kg-embed-card iframe'))
}

// Gallery

function gallery() {
    'use strict';
    var images = document.querySelectorAll('.kg-gallery-image img');
    images.forEach(function(image) {
        var container = image.closest('.kg-gallery-image');
        var width = image.attributes.width.value;
        var height = image.attributes.height.value;
        var ratio = width / height;
        container.style.flex = ratio + ' 1 0%';
        image.classList.add('lazyload')
    });
}

//sticky Nav
function stickyNav() {
    'use strict';
    const scrollUp = "scroll-up";
    const scrollDown = "scroll-down";
    let lastScroll = 0;


    window.addEventListener("scroll", () => {
    const currentScroll = window.pageYOffset;
    if (currentScroll <= 0) {
        body.classList.remove(scrollUp);
        return;
    }

    if (currentScroll > lastScroll && !body.classList.contains(scrollDown)) {
        // down
        body.classList.remove(scrollUp);
        body.classList.add(scrollDown);
    } else if (
        currentScroll < lastScroll &&
        body.classList.contains(scrollDown)
    ) {
        // up
        body.classList.remove(scrollDown);
        body.classList.add(scrollUp);
    }
    lastScroll = currentScroll;
    });
}

//DarkMode

function niteMode() {
    var darkLight = document.querySelector('.dark-light');
    darkLight.addEventListener('click', function(){
    if(html.getAttribute('data-theme') === 'dark'){
        html.setAttribute('data-theme', 'light')
        localStorage.setItem('selected-theme', 'light');
    }else{
        html.setAttribute('data-theme', 'dark')
        localStorage.setItem('selected-theme', 'dark');
    }
    });
}